var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHP03F9C77(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9962_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05815 0 0 8.05905 0 18C0 27.941 8.05815 36 18 36C27.9419 36 36 27.9414 36 18C36 8.0586 27.9419 0 18 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34.6712C17.8339 34.6712 17.6688 34.668 17.5045 34.6635L20.9115 25.2999H25.6C26.4226 25.2999 27.3267 24.6672 27.6075 23.8946L31.3038 13.7412C31.9081 12.0789 30.9564 10.719 29.1874 10.719H22.6827L17.2251 25.7171H17.2228L14.1286 34.2185C6.78869 32.4729 1.32884 25.875 1.32884 18C1.32884 10.125 6.47819 3.90826 13.4986 1.94401L10.3054 10.7186L4.99679 25.299H8.53019L13.0437 12.9092H15.6987L11.1852 25.299H14.7168L18.9234 13.7403C19.5286 12.078 18.576 10.7181 16.8093 10.7181H13.8393L17.2507 1.34641C17.4991 1.33561 17.7484 1.32886 18 1.32886C27.207 1.32886 34.6711 8.79301 34.6711 18C34.6711 27.207 27.207 34.6712 18 34.6712ZM28.0867 12.9015H25.4326L21.7147 23.1017H24.3697L28.0867 12.9015Z",
    fill: "#024AD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9962_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHP03F9C77);
export default __webpack_public_path__ + "static/media/hP.03f9c77.05f6028de6b55f68631d3546325b60e9.svg";
export { ForwardRef as ReactComponent };